import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MSG_OBG_PARTE_REQUERENTE, MSG_OBG_TELEFONE} from "../../../../../tools/Mensagens";
import {AplicarRegraCampos} from "../../validators/aplicar-regra-campos";
import {CampoObrigatorio} from "../../validators/campo-obrigatorio";

@Component({
  selector: 'app-parte-informacao-requerente',
  templateUrl: './parte-informacao-requerente.component.html',
  styleUrls: ['./parte-informacao-requerente.component.css']
})
export class ParteInformacaoRequerenteComponent implements OnInit, OnDestroy {

  @Input() formulario: FormGroup;
  @Input() somenteLeitura: boolean;
  @Input() dados: string;

  constructor() {
  }

  ngOnInit() {
    if(!this.somenteLeitura) {
      this.formulario.addControl('informacaoRequerenteParte', new FormControl('', Validators.required));
      this.formulario.get('informacaoRequerenteParte').setValue(this.dados);
    }
    }


  ngOnDestroy() {
    if(!this.somenteLeitura) {
      this.formulario.removeControl('informacaoRequerenteParte');
    }
  }

  public validarFormulario() {
    const campos = [
      {control: 'informacaoRequerenteParte', mensagem: MSG_OBG_PARTE_REQUERENTE, regra: this.validarParte.bind(this)},
    ];
    AplicarRegraCampos.aplicar(campos, this.formulario);
  }

  private validarParte(value: any): boolean {
    return CampoObrigatorio.aplicar(value);
  }


}
